import styles from "./Card.module.css";

function Card({data}) {
    return <div className={styles.card}>
        {data}
    </div>
}

export default Card;